import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-806"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M8 0a8.031 8.031 0 0 0-1.065.079 7.992 7.992 0 0 0-.354 15.788h.001A7.952 7.952 0 0 0 8 16 8 8 0 0 0 8 0zM1 8a7.008 7.008 0 0 1 6.204-6.951A25.25 25.25 0 0 1 8 7.5a24.131 24.131 0 0 1-1.067 7.41A7.005 7.005 0 0 1 1 8z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }